import * as React from 'react';
import { ActionPlanStatus, TApiActionPlanEntity } from '../../types/Actionplan';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import ListItemText from '@mui/material/ListItemText';
import List from '@mui/material/List';
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import { simpleDateFormat } from '../../Helpers';
import { isEmpty } from 'lodash';
import { getActionPlanStyling } from '../../containers/pages/actionplans/ActionPlanListPage';

interface IActionPlanListProps {
  actionPlans: Array<TApiActionPlanEntity>;
  onSelect: (id: number) => void;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    icon: {
      backgroundColor: 'white',
    },
  })
);

const ActionPlanList: React.FC<IActionPlanListProps> = (props): JSX.Element => {
  const classes = useStyles({});
  const { t } = useTranslation();

  if (isEmpty(props.actionPlans)) {
    return <>{t('list.is.empty')}</>;
  }

  return (
    <List className={classes.root}>
      {props.actionPlans.map((actionPlan: TApiActionPlanEntity) => {
        const secondaryTitle = `${t(actionPlan.statusLabel)} - ${t(
          'actionplan.endDate'
        )} ${simpleDateFormat(actionPlan.endDate)}`;

        return (
          <ListItem
            button
            key={actionPlan.id}
            onClick={() => props.onSelect(actionPlan.id)}
          >
            <ListItemAvatar>
              <Avatar
                className={classes.icon}
                style={{
                  color: getActionPlanStyling(
                    actionPlan.status as ActionPlanStatus
                  ).color,
                }}
              >
                {
                  getActionPlanStyling(actionPlan.status as ActionPlanStatus)
                    .icon
                }
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={actionPlan.name}
              secondary={secondaryTitle}
            />
          </ListItem>
        );
      })}
    </List>
  );
};

export default ActionPlanList;
